import type { ReactNode } from "react";


interface LoadingPlaceholderProps {
    children?: ReactNode;
}


export function LoadingPlaceholder({ children }: LoadingPlaceholderProps) {
    if (!children) {
        children = (<div className="absolute inset-3 rounded-xl bg-surface-sunken" />);
    }
    return (
        <div className={"relative min-h-[80vh] opacity-30 animate-fade-in-out"}>
            {children}
        </div>
    );
}
